module.exports = __webpack_public_path__ + "img/bird-9-right.43f5fa41.png";